import { render, staticRenderFns } from "./button-additem-reports.vue?vue&type=template&id=5d8223cb&"
import script from "./button-additem-reports.vue?vue&type=script&lang=js&"
export * from "./button-additem-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports